export
const name: string = "LineId";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform lowp int   u_line_type;
`;

export
const varyings: string = `
    varying lowp float v_distance_from_origin;
    varying      vec4  v_object_id;
`;

export
const implementation: string = `
    void main()
    {
    #ifdef CLIPPING_PLANE
        resolveClippingPlane();
    #endif

        // -1: full line, -256: dashed line
        if (u_line_type == -256 && fract(v_distance_from_origin * 2.0 / 2.0) > 0.5) discard;

        gl_FragColor = v_object_id;
    }
`;
